import { motion } from "framer-motion";
import { DesktopNavbar } from "./desktop-navbar";
import { MobileNavbar } from "./mobile-navbar";

const navItems = [
  {
    title: "Features",
    link: "features",
  },
  {
    title: "Tools",
    link: "tools",
  },
  {
    title: "FAQ",
    link: "faq",
  },
  {
    title: "Pricing",
    link: "pricing",
  },
];

export function NavBar() {
  return (
    <motion.nav
      initial={{
        y: -80,
      }}
      animate={{
        y: 0,
      }}
      transition={{
        ease: [0.6, 0.05, 0.1, 0.9],
        duration: 1.2,
      }}
      className="max-w-7xl  fixed top-4  mx-auto inset-x-0 z-[100] w-[95%] lg:w-full dark"
    >
      <div className="hidden lg:block w-full">
        <DesktopNavbar navItems={navItems} />
      </div>
      <div className="flex h-full w-full items-center lg:hidden ">
        <MobileNavbar navItems={navItems} />
      </div>
    </motion.nav>
  );
}
